import { render, staticRenderFns } from "./content-sheet-ayuda.vue?vue&type=template&id=d16fef12&scoped=true&"
import script from "./content-sheet-ayuda.vue?vue&type=script&lang=js&"
export * from "./content-sheet-ayuda.vue?vue&type=script&lang=js&"
import style0 from "./content-sheet-ayuda.vue?vue&type=style&index=0&id=d16fef12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16fef12",
  null
  
)

export default component.exports